/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  default-case,
  eqeqeq,
  import/no-extraneous-dependencies,
  max-len,
  no-cond-assign,
  no-param-reassign,
  no-prototype-builtins,
  no-restricted-syntax,
  no-void,
  react/no-find-dom-node,
  react/no-string-refs
*/
import './index.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import Logo from 'signer/components/common/logo';
import Fixed from 'signer/components/common/fixed';
import logger from 'common/logger';
import NavHeader from 'signer/components/common/nav-header';
import setTimeout from 'common/utils/set-timeout';
import HeaderAlertTypes from 'signer/components/common/header-alert/header-alert-types';
import HeaderButton from 'signer/components/common/header-button';
import CheckboxHelper from 'signer/utils/checkbox-helper';
import HeaderMenu from 'signer/components/common/header-menu';
import createReactClass from 'create-react-class';
import SigDoc from 'hellospa/components/signer-signature-document';
import { FormattedMessage, FormattedHTMLMessage, defineMessages, useIntl } from 'react-intl';
import { removeBannerMessage, useLocalBanner } from 'hellospa/page/prep-and-send/data/actions';
import NotificationList, { NotificationBannerType } from 'hellospa/components/notification-banner';
import { useDispatch } from 'react-redux';

/**
 * WARNING: This is SUPER hacky.
 *
 * I'm being extra careful not to change the behavior of this component. The
 * banner info really should be state, but instead this figures out what to
 * show on each render. There is also this odd pattern of calling
 * this.closeBannerAfterTimeout() in various places. Instead of doing a full
 * refactor I changed renderAlert and closeBannerAfterTimeout to work with the
 * banners in Redux.
 *
 * I have preserved the old behavior by using <AlertAdapter to create/replace
 * its banner when it renders. If it unmounts then it'll automatically clear
 * its banner (see useLocalBanner). It also passes the ID back up so that
 * closeBannerAfterTimeout can remove the banner.
 */
const bannerId = Symbol('bannerId');

const bannerMap = {
  [HeaderAlertTypes.SUCCESS]: NotificationBannerType.Success,
  [HeaderAlertTypes.ERROR]: NotificationBannerType.Err,
  [HeaderAlertTypes.INFO]: NotificationBannerType.Info,
  [HeaderAlertTypes.INSTRUCTIONS]: NotificationBannerType.Info,
};
function AlertAdapter({ type, message, timeout, onAlertCreated }) {
  const dispatch = useDispatch();
  const { createTranslatedBannerMessage } = useLocalBanner();

  React.useEffect(() => {
    // I added a fallback just in case something is passing an invalid type.
    const bannerType = bannerMap[type] || NotificationBannerType.Info;

    const id = createTranslatedBannerMessage(
      message,
      bannerType,
      {
        // The previous implementation only allowed one banner at a time
        key: 'alert-adapter',
        timeout,
      },
    );
    onAlertCreated(id);
  }, [createTranslatedBannerMessage, dispatch, message, onAlertCreated, timeout, type]);

  return null;
}

const messages = defineMessages({
  allRequiredFieldsCompleted: {
    id: 'signer.document.alert.allRequiredFieldsCompleted',
    description: 'notification message in singer flow, shows when all fields are filled by signer',
    defaultMessage: '{ isDesktop, select, 1 {You have completed all required fields. Please click \'Continue\'.} 0 {Required fields are done. Tap \'Continue\'.} }',
  },
  groupMinReqText: {
    id: 'signer.field.groupMinReqText',
    description: 'alert message in singer flow, informing singer that checkboxes are required fields',
    defaultMessage: 'At least {min} { min, plural, =1 {checkbox is} other {checkboxes are} } required',
  },
  groupMinMaxReqText: {
    id: 'signer.field.groupMinMaxReqText',
    description: 'alert message in singer flow, informing singer that only some number of checkboxes can be selected',
    defaultMessage: '{min} to {max} { max, plural, =1 {checkbox} other {checkboxes} } can be selected',
  },
  groupCheckboxMaxReqText: {
    id: 'signer.field.groupCheckboxMaxReqText',
    description: 'alert message in signing flow informing signer the most amount of checckboxes can be selected, max will always be greater then 1',
    defaultMessage: 'At most {max} checkboxes can be selected',
  },
  groupRadioMaxReqText: {
    id: 'signer.field.groupRadioMaxReqText',
    description: 'alert message in signing flow informing signer the most amount of radio buttons can be selected, max will always be greater then 1',
    defaultMessage: 'At most {max} radio buttons can be selected',
  },
  groupCheckboxSameMinMaxReqText: {
    id: 'signer.field.groupCheckboxSameMinMaxReqText',
    description: 'alert message in signing flow informing signer the number of checkboxes that must be selected',
    defaultMessage: '{min} { min, plural, =1 {checkbox} other {checkboxes} } must be selected',
  },
  groupRadioSameMinMaxReqText: {
    id: 'signer.field.groupRadioSameMinMaxReqText',
    description: 'alert message in signing flow informing signer the number of radio buttons that must be selected',
    defaultMessage: '{min} { min, plural, =1 {radio button} other {radio buttons} } must be selected',
  },
});

// In seconds
const GROUP_INFO_TTL = 10 * 1000;
const DEFAULT_ALERT_TTL = 4 * 1000;

const SignatureRequest = createReactClass({

  //  ----  LIFECYCLE  ----------------------------------

  /**
    */

  componentDidMount() {
    logger.track('SignatureRequest.componentDidMount');

    this.props.app.notifier.push(this);
    const root = ReactDOM.findDOMNode(this);
    root.addEventListener('keydown', this.handleKeyDown);
    root.addEventListener('keyup', this.handleKeyUp);
  },

  /**
    */

  componentWillUnmount() {

    this.props.app.notifier.remove(this);

    const root = ReactDOM.findDOMNode(this);
    root.removeEventListener('keydown', this.handleKeyDown);
    root.removeEventListener('keyup', this.handleKeyUp);
  },

  /**
    */

  getInitialState() {
    return {
      error: this.props.error,
      headerMenuIsShown: false,
    };
  },


  //  ----  HELPERS  ------------------------------------

  /**
    */

  getCurrentField() {

    const location = this.props.location;
    const locationState = location.state;

    return locationState
      .signatureRequest
      .findField(locationState.currentField);
  },

  handleKeyDown(evt) {

    let currentField;

    switch (evt.which || evt.keyCode) {

      case 9: // Tab
        // NOTE: We need to save which field is current now because currentField
        // will have changed by the time we get to handleKeyUp for components that
        // natively support shift-tabbing.
        this.currentFieldOnKeyDown = this.getCurrentField();
        evt.preventDefault();
        return false;

      case 32: // Space
        currentField = this.getCurrentField();
        if (currentField && currentField.type === 'checkbox') {
          // Prevent paging down when using the space bar to toggle checkboxes
          evt.preventDefault();
        }
        break;
    }
  },

  handleKeyUp(evt) {

    let currentField = this.getCurrentField();
    const signatureRequest = this.props.app.signatureRequest;

    if (currentField.hasDataValue() && currentField.hasDataValidation()) {
      // force a re-render
      this.setState({});
    }

    switch (evt.which || evt.keyCode) {

      case 9: // Tab

        currentField = this.currentFieldOnKeyDown;
        this.currentFieldOnKeyDown = null;

        if (currentField) {

          if (currentField.getDataValidationError()) {
            // Prevent from tabbing away if there's a validation error
            evt.preventDefault();
          }

          if (evt.shiftKey === true) {
            const prevField = signatureRequest.getPrevEditableField(currentField);
            if (prevField) {
              this.setStep(currentField, prevField, null, evt, true);
            }
          } else {
            const nextInvalidField = signatureRequest.getNextInvalidField(currentField) || signatureRequest.getNextInvalidField();
            let nextField = signatureRequest.getNextEditableField(currentField) || nextInvalidField;
            if (!nextField && currentField.getDataValidationError()) {
              nextField = currentField;
            }
            if (nextField) {
              let validate = false;
              const nextEmptyField = signatureRequest.getNextEmptyField(nextField);
              if (!nextEmptyField || nextEmptyField.isBefore(currentField)) {
                validate = true;
              }

              this.setStep(currentField, nextField, validate, evt);
            }
          }
        }
        break;

      case 32: // Space
        if (currentField && currentField.type === 'checkbox') {
          CheckboxHelper.toggle(null, currentField);
        }
        break;
    }
  },

  /**
    */

  getStarted() {
    this.props.app.router.redirect('signNext', {
      params: {
        field: this.props.signatureRequest.getNextEditableField(),
      },
    });
  },

  /**
    */

  prevStep() {
    this.props.app.router.redirect('preview');
  },

  /**
    */

  notify(message) {

    if (message.name !== 'alertSuccess') {
      return;
    }

    this.setState({
      bannerInfo: message,
    });

    this.closeBannerAfterTimeout();
  },

  /**
    */

  setStep(currentField, field, validate, evt, skipValidation) {

    if (evt) {
      evt.preventDefault();
    } else if (!field) {
      return this.props.app.router.redirect('preview');
    }

    let error;
    const state = this.props.location.state;

    if (!currentField) {
      currentField = state.signatureRequest.findField(state.currentField);
    }

    if (currentField.getDataValidationError()) {
      if (!currentField.hasDataValue()) {
        // the user typed and pressed tab really quickly - data value is not set
        // yet, so we can set it manually here.
        currentField.data = currentField.toData();
        // force a re-render
        this.setState({});
      }
      return;
    }

    if (skipValidation !== true) {
      if (state.validate && (error = currentField.getValidationError())) {
        this.setState({
          error,
        });
        return this.closeBannerAfterTimeout();
      }
    }

    this.props.app.router.redirect('signNext', {
      params: {
        field,
      },
      query: {
        validate: validate != void 0 ? validate : state.validate,
      },
    });
  },

  /**
    */

  closeBannerAfterTimeout() {
    if (this.bannerTimeoutId) {
      clearTimeout(this.bannerTimeoutId);
    }
    this.bannerTimeoutId = setTimeout(() => {
      if (this[bannerId]) {
        this.props.dispatch(removeBannerMessage(this.bannerId));
        this[bannerId] = undefined;
      }
      this.setState({
        bannerInfo: void 0,
        error: void 0,
      });
    }, DEFAULT_ALERT_TTL);
  },

  /**
    */

  complete() {
    if (this.props.location.state.signatureRequest.isValid()) {
      if (this.props.location.state.signatureRequest.data.signatureRequestData.hasOwnProperty('attachment_slots')) {
        this.props.app.router.redirect('attachments');
      } else if (this.props.location.state.signatureRequest.isQualifiedSignature()) {
        this.props.app.router.displayFullScreenModal('confirmQualifiedSignature');
      } else {
        this.props.app.router.redirect('confirm');
      }
    }
  },

  /**
    */

  hasGroupRules(currentField) {
    if (currentField && currentField.type === 'group') {
      return (
        currentField.editable === true
                && currentField.required === true
                && currentField.children.length > 0
                && !!currentField.validationOptions
      );
    }
    return false;
  },

  /**
     */

  hideAlert() {
    const node = this.refs.headerAlert;
    if (node) {
      node.style.display = 'none';
    }
  },

  /**
     */

  onHeaderMenuToggle(isShown) {
    this.setState({
      headerMenuIsShown: !!isShown,
    });
  },

  //  ----  RENDERING  ----------------------------------

  /**
    */

  render() {

    const sections = {};
    const location = this.props.location;
    const locationState = location.state;
    const signatureRequest = locationState.signatureRequest;
    const currentField = signatureRequest.findField(locationState.currentField);
    const hasEditableFields = !!signatureRequest.getNumEditableFields();
    const prevField = signatureRequest.getPrevEditableField(currentField);
    let nextField = signatureRequest.getNextEmptyField(currentField);
    const emptyReqField = signatureRequest.getFirstRequiredEmptyField();
    const nextInvalidField = signatureRequest.getNextInvalidField(currentField) || signatureRequest.getNextInvalidField();
    let validate = locationState.validate;
    let error = this.state.error;
    const reqFieldsLeft = signatureRequest.getRequiredFieldsLeftCount();
    let isButtonDisabled = false;
    const showArrowCtrls = (nextField && emptyReqField) || nextInvalidField;

    if (currentField) {

      if (hasEditableFields) {
        if (!error && !validate && this.hasGroupRules(currentField)) {
          if (currentField.isEdited()) {
            // Validate if it's been edited
            error = currentField.getValidationError();
          } else {
            // Only show rules if it hasn't been edited
            sections.alert = this.renderGroupRulesAlert(currentField);
          }
        }

        if (currentField.hasDataValidation() && currentField.hasDataValue()) {
          error = currentField.getDataValidationError();
          isButtonDisabled = !!error;
        }

        if (validate && !error) {
          error = currentField.getValidationError();
        }

        if (!nextField) {
          validate = !signatureRequest.isValid();
        }

        if (validate) {
          nextField = nextInvalidField;
        }
      }

      if (!this.state.headerMenuIsShown) {
        if (error) {
          sections.alert = this.renderAlert(HeaderAlertTypes.ERROR, null, error.message); // this.props.intl.formatMessage({ id: `error.${error.message}` }, currentField.validationOptions));
        }

        if (this.state.bannerInfo) {
          sections.alert = this.renderAlert(HeaderAlertTypes.SUCCESS, 'ion-checkmark-circled', this.props.intl.formatMessage({ id: this.state.bannerInfo.message }, this.state.bannerInfo.params));
        }
      }
    }


    if (!showArrowCtrls) {

      if (!this.state.headerMenuIsShown) {
        sections.alert = this.renderAlert(HeaderAlertTypes.SUCCESS, 'ion-checkmark-circled', this.props.intl.formatMessage(messages.allRequiredFieldsCompleted, { isDesktop: this.props.app.isDesktop ? 1 : 0 }));
      }
      sections.nextButton = (
        <HeaderButton data-qa-ref='button-next' className='m-signature-request--header-next-button whitelabel-primary-button' onClick={this.complete} {...this.props}>
          <FormattedMessage
            id='common.continueButton.labelText'
            description='button text when clicked redirects to new page'
            defaultMessage='Continue' />
        </HeaderButton>
      );

    } else if (currentField) {

      if (!validate && prevField) {
        sections.previousButton = (
          <a href='#' onClick={this.setStep.bind(this, currentField, prevField, false)} className='m-signature-request--header-prev-button'>
            <i className='ion-ios-arrow-back'></i>
          </a>
        );
      }

      sections.nextButton = (
        <HeaderButton data-qa-ref='button-next' className={'m-signature-request--header-next-button whitelabel-primary-button'} onClick={this.setStep.bind(this, currentField, nextField, validate)} disabled={!!isButtonDisabled} {...this.props}>
          { validate
            ? <FormattedHTMLMessage
              id="signer.nav.nextReqMessage"
              description="button text in signer flow when clicked highlights the next required field to be filled by signer"
              defaultMessage="Next Req*" />
            : <FormattedHTMLMessage
              id="signer.nav.nextMessage"
              description="button text in singer flow when clicked points to the next field to be filled by signer"
              defaultMessage="Next" />
          }
          <i className='ion-ios-arrow-forward'></i>
        </HeaderButton>
      );

    }

    /**
        * Conditional elements for desktop (not used in mobile page)
        * */

    const showLogo = !this.props.app.isEmbedded() && !this.props.app.whitelabel;
    const HFLogo = showLogo ? (
      <span className='m-signature-request--header--logo'>
        <Logo dark={true} {...this.props} showIfCustom={false} />
      </span>
    ) : null;

    const showHeaderMenu = (this.props.app.canDownload() || this.props.app.canDecline() || this.props.app.canCancel());
    let headMenu;
    if (showHeaderMenu) {
      headMenu = <HeaderMenu
        onMenuToggle={this.onHeaderMenuToggle}
        canDelegate={this.props.app.canDelegate()}
        {...this.props} />;
    }

    // I need to make sure this always passes the same function. I don't
    // remember how to do this with `createReactClass`, so I think this hack
    // is good enough.
    this.forceUpdateHack = this.forceUpdateHack || this.forceUpdate.bind(this);

    return (
      <div className='m-signature-request'>

        <Fixed {...this.props} absolute={true}>
          <NavHeader className='m-signature-request--header small' {...this.props}>

            { headMenu }
            { HFLogo }
            <span className='m-signature-request--header-fields-left whitelabel-fields-left' style={{ visibility: reqFieldsLeft ? 'visible' : 'hidden' }}>
              { validate
                ? <FormattedHTMLMessage
                  id="signer.nav.fieldsLeftMiniMessage"
                  description="text in signer flow nav bar indicates signer how many fields needs to be filled"
                  defaultMessage="REQ<span class='m-signature-request--header-required-field'>*</span> { fieldsLeft, plural, =1 { field } other { fields } } left <span class='m-signature-request--header-fields-left-count'>{fieldsLeft}</span>"
                  values={{
                    fieldsLeft: String(reqFieldsLeft),
                  }} />
                : <FormattedHTMLMessage
                  id="signer.nav.fieldsLeftMessage"
                  description="text in navbar of signer flow, informing signer the number of fields left to fill"
                  defaultMessage="REQ<span class='m-signature-request--header-required-field'>*</span> { fieldsLeft, plural, =1 { field } other { fields } } left <span class='m-signature-request--header-fields-left-count'>{fieldsLeft}</span>"
                  values={{
                    fieldsLeft: String(reqFieldsLeft),
                  }} />
                }
            </span>
            <div className='m-signature-request--header-nav-right'>
              {sections.previousButton}
              {sections.nextButton}
              <br />
            </div>
          </NavHeader>

          {sections.alert}
          <NotificationList className="m-signature-request-notifications" />

        </Fixed>
        <SigDoc
          setCustomNotification={this.setCustomNotification}
          forceUpdateHack={this.forceUpdateHack}
          legacyApp={this.props.app}
          dateFormat={this.props.signatureRequest.settings.dateFormat}
          error={error} />

      </div>
    );
  },

  /**
    */

  renderGroupRulesAlert(currentField) {

    let key;
    const params = {};

    for (const k in currentField.validationOptions) {
      if (currentField.validationOptions[k] !== null) {
        params[k] = currentField.validationOptions[k];
      }
    }

    // Instead of using currentField.data.children[0]
    // can't be certain children are properly 0-indexed
    const firstChild = currentField.data.children.find((_field) => true);

    if (currentField.validationOptions.min > 0) {
      if (currentField.validationOptions.max === null || currentField.validationOptions.max === undefined) {
        // Only min requirement
        key = this.props.intl.formatMessage(messages.groupMinReqText, params);
      } else if (currentField.validationOptions.min === currentField.validationOptions.max) {
        // Only one way
        key = firstChild.type === 'radiobutton'
          ? this.props.intl.formatMessage(messages.groupRadioSameMinMaxReqText, params)
          : this.props.intl.formatMessage(messages.groupCheckboxSameMinMaxReqText, params);
      } else {
        // Both min and max requirements
        key = this.props.intl.formatMessage(messages.groupMinMaxReqText, params);
      }
    } else if (currentField.validationOptions.max > 0) {
      // Only max requirement
      key = firstChild.type === 'radiobutton'
        ? this.props.intl.formatMessage(messages.groupRadioMaxReqText, params)
        : this.props.intl.formatMessage(messages.groupCheckboxMaxReqText, params);
    }

    if (key) {

      return this.renderAlert(HeaderAlertTypes.INFO, 'ion-information-circled', key, GROUP_INFO_TTL);
    }
  },


  renderAlert(type, icon, message, timeout) {
    const setId = (id) => {
      this[bannerId] = id;
    };
    return (
      <AlertAdapter
        type={type}
        message={message}
        onAlertCreated={setId}
        timeout={timeout} />
    );
  },
});

export default function SignatureRequestWrapper(props) {
  const intl = useIntl();
  const dispatch = useDispatch();
  return (
    <SignatureRequest
      {...props}
      dispatch={dispatch}
      intl={intl} />
  );
}
